// ── Clock-In session sync (server-visible planned end time) ─────────────────
// A minimal Firestore mirror of the currently-running Clock-In countdown, so
// api/cron/send-alarm-pushes.js can see "this user's timer is about to hit
// zero" and push an alarm_ring even if the app/device is otherwise dormant.
// Follows the existing flat-field-on-user-doc convention already used for
// fcmTokens (see src/capacitor/nativePush.js) rather than a new subcollection.
// Deliberately NOT the full focus-timer state (mode, pause, elapsed, etc.) —
// just enough for the server to know when to ring and what to call it.
// Best-effort only: never blocks or throws into the in-app timer.
import { doc, setDoc, updateDoc, deleteField } from 'firebase/firestore';
import { db, isFirebaseConfigured } from './config';

// Call whenever a countdown Clock-In session is actively running toward a
// known end time (start and resume). `endsAt` is an epoch-ms number or an
// ISO string; stored as ISO so the server's `new Date(...)` parse is exact.
export async function syncClockInSession(uid, { endsAt, label }) {
  if (!isFirebaseConfigured || !uid || !endsAt) return;
  try {
    await setDoc(doc(db, 'users', uid), {
      clockInSession: { endsAt: new Date(endsAt).toISOString(), label: label || 'Clock-In' },
    }, { merge: true });
  } catch { /* best-effort — never block the in-app timer on this */ }
}

// Call on pause/stop/finish/session-complete, and for stopwatch mode (no
// fixed end time to ring for at all).
export async function clearClockInSession(uid) {
  if (!isFirebaseConfigured || !uid) return;
  try {
    await updateDoc(doc(db, 'users', uid), { clockInSession: deleteField() });
  } catch { /* best-effort; e.g. doc doesn't exist yet — nothing to clear */ }
}
